import MonetizationForm from '../components/monetization/MonetizationForm';

export interface MonetizationFormData {
  company_name: string;
  cuit: string;
  currency: string;
  product_line_label: string;
  product_line_code: string;
  guarantee_type: string;
  guarantee_type_name: string;
  guarantee_types: Array<{ id: number; type: string; label: string; name: string; name_end_user?: string }>;
  creditors: Array<{ id: number; name: string }>;
  amortization_types?: Array<{ id: number; name: string }>;
  payment_frequency_types?: Array<{ id: number; name: string }>;
  rate_types?: Array<{ id: number; name: string }>;
  check_format_types?: Array<{ id: number; name: string }>;
  purpose_types?: Array<{ id: number; name: string }>;
}

export interface FormValues {
  // General fields
  product_line_id: string;
  issue_date: string;
  created_at?: string;
  guarantee_type_id: number | null;
  
  // Common fields
  monetization_amount: number | null;
  monetization_date?: string;
  due_date: string;
  creditor_id: number | null;
  
  // Loan specific fields
  bank_operation_number?: string;
  amortization_type_id?: number | null;
  payment_frequency_type_id?: number | null;
  term_in_days?: number | null;
  rate_type_id?: number | null;
  percentage_point?: number | null;
  grace_period?: number | null;
  purpose_type_id?: number | null;
  is_syndicated?: boolean;
  syndicated_number?: string;
  
  // Check specific fields
  bank_branch?: string;
  check_format_type_id?: number | null;
  check_number?: string;
  echeck_number?: string;
  cmc7?: string;
  estimated_payment_date?: string;
  banking_entity_id?: number | null;
  banking_entity_name?: string;
  postal_code?: string;
  drawer?: {
    cuit: string;
    company_name?: string;
  };
  
  // Promissory Note specific fields
  endorsed?: boolean;
  e_promissory_note_id?: string;
  
  observation?: string;
  
  // Execution fields (for edit mode)
  // For checks and promissory notes
  monetization_cvba_code?: string;
  iva?: boolean;
  monetization_discount_rate?: number | null;
  monetization_interest?: number | null;
  clearing?: number | null;
  settlement_date?: string;
  buyer_alyc?: string;
  seller_alyc?: string;
  
  // For loans
  bank_contract_file?: string;
  pending_file?: File | null; // Archivo pendiente de subir
  id_global?: number | null; // ID global para upload

  // Asset fields (ticket #50804 - carga de aval en otro activo)
  asset_id?: number | null;
  asset_quantity?: number | null;
  asset_quotation?: number | null;

}

const MonetizationNew = () => {
  return <MonetizationForm mode="create" />;
};

export default MonetizationNew;
